 class FreeShippingBar {
  constructor({ targetSelector = '.js-free-shipping-bar' } = {}) {
    const cfg = window.FREE_SHIPPING_CONFIG || {};
    this.threshold    = cfg.threshold || window.FREE_SHIPPING_THRESHOLD || 500;
    this.giftEnabled  = cfg.giftEnabled  || false;
    this.giftThreshold = cfg.giftThreshold || 300;
    this.textProgress       = cfg.textProgress       || 'Adauga {amount} RON pentru transport gratuit';
    this.textReached        = cfg.textReached        || 'Felicitari! Ai transport gratuit!';
    this.textReachedWithGift = cfg.textReachedWithGift || 'Felicitari! Ai transport gratuit! Adauga {amount} RON pentru cadoul gratuit';
    this.textAllReached     = cfg.textAllReached     || 'Felicitari! Ai transport gratuit si cadoul gratuit!';
    this.targetSelector = targetSelector;
    this.cartTotal = 0;
    this.init();
  }

  get maxThreshold() {
    return this.giftEnabled ? Math.max(this.threshold, this.giftThreshold) : this.threshold;
  }

  init() {
    this.injectBar();
    this.fetchAndUpdate();
    document.addEventListener('cartAdded',   () => this.fetchAndUpdate());
    document.addEventListener('cartUpdated', () => this.fetchAndUpdate());
  }

  injectBar() {
    const containers = document.querySelectorAll(this.targetSelector);
    if (!containers.length) return;

    const shippingPct = ((this.threshold     / this.maxThreshold) * 100).toFixed(2);
    const giftPct     = ((this.giftThreshold / this.maxThreshold) * 100).toFixed(2);

    // Shipping marker – only visible when gift extends the bar beyond shipping threshold
    const shippingMarker = (this.giftEnabled && this.giftThreshold > this.threshold) ? `
      <div class="fs-bar__milestone fs-bar__milestone--shipping" style="left:${shippingPct}%">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-7 1.5 2H17V9.5h2.5L18 11z"/>
        </svg>
      </div>` : '';

    // Gift marker – only when gift is enabled
    const giftMarker = this.giftEnabled ? `
      <div class="fs-bar__milestone fs-bar__milestone--gift" style="left:${giftPct}%">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 6h-2.18c.07-.28.18-.51.18-.75C18 3.45 16.55 2 14.75 2c-.86 0-1.64.36-2.14.97l-.61.68-.61-.68C10.89 2.36 10.11 2 9.25 2 7.45 2 6 3.45 6 5.25c0 .24.04.47.11.75H4c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1h1v7c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h1c.55 0 1-.45 1-1V8c0-1.1-.9-2-2-2zm-5.25-2c.69 0 1.25.56 1.25 1.25S15.44 6.5 14.75 6.5H13V5c0-.69.56-1.25 1.25-1.25zm-5.5 0C9.94 4 10.5 4.56 10.5 5.25V6.5H9.25C8.56 6.5 8 5.94 8 5.25S8.56 4 9.25 4zM4 8h7v2H4V8zm2 11V11h5v8H6zm10 0h-3v-8h5v7c0 .55-.45 1-1 1zm2-9h-7V8h7v2z"/>
        </svg>
      </div>` : '';

    containers.forEach(container => {
      if (container.querySelector('.fs-bar__message')) return;

      container.innerHTML = `
        <div class="fs-bar__message">
          <span class="fs-bar__text">&#x1F6D2; Calculam transportul gratuit...</span>
        </div>
        <div class="fs-bar__progress-wrapper">
          <div class="fs-bar__progress">
            <div class="fs-bar__progress-fill"></div>
            <div class="fs-bar__progress-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-7 1.5 2H17V9.5h2.5L18 11z"/>
              </svg>
            </div>
            ${shippingMarker}
            ${giftMarker}
          </div>
        </div>
      `;
    });
  }

  updateBarMessage() {
    const containers = document.querySelectorAll(this.targetSelector);
    if (!containers.length) return;

    const rawPct    = (this.cartTotal / this.maxThreshold) * 100;
    const maxPct    = window.innerWidth < 768 ? 97 : 100;
    const percentage = Math.min(maxPct, rawPct).toFixed(2);

    const shippingReached = this.cartTotal >= this.threshold;
    const giftReached     = this.giftEnabled && this.cartTotal >= this.giftThreshold;

    containers.forEach(container => {
      const messageEl   = container.querySelector('.fs-bar__text');
      const fillEl      = container.querySelector('.fs-bar__progress-fill');
      const iconEl      = container.querySelector('.fs-bar__progress-icon');
      const giftEl      = container.querySelector('.fs-bar__milestone--gift');
      const shippingEl  = container.querySelector('.fs-bar__milestone--shipping');

      if (!messageEl || !fillEl) return;

      fillEl.style.width = `${percentage}%`;
      if (iconEl) iconEl.style.left = `${percentage}%`;

      if (shippingEl) shippingEl.classList.toggle('is-reached', shippingReached);
      if (giftEl) {
        giftEl.classList.toggle('is-reached',   giftReached);
        giftEl.classList.toggle('is-jiggling', !giftReached);
      }

      if (this.giftEnabled) {
        if (giftReached) {
          messageEl.innerHTML = this.textAllReached;
        } else if (shippingReached) {
          const rem = (this.giftThreshold - this.cartTotal).toFixed(2);
          messageEl.innerHTML = this.textReachedWithGift.replace('{amount}', `<strong>${rem}</strong>`);
        } else {
          const rem = (this.threshold - this.cartTotal).toFixed(2);
          messageEl.innerHTML = this.textProgress.replace('{amount}', `<strong>${rem}</strong>`);
        }
      } else {
        if (shippingReached) {
          messageEl.innerHTML = this.textReached;
        } else {
          const rem = (this.threshold - this.cartTotal).toFixed(2);
          messageEl.innerHTML = this.textProgress.replace('{amount}', `<strong>${rem}</strong>`);
        }
      }
    });
  }

  async fetchAndUpdate() {
    try {
      const response = await fetch('/cart.js');
      const data     = await response.json();
      this.cartTotal = data.total_price / 100;
      this.updateBarMessage();
    } catch (error) {
      console.error('Eroare la preluarea cosului:', error);
    }
  }
}

let freeShippingBarInstance;

document.addEventListener('DOMContentLoaded', () => {
  freeShippingBarInstance = new FreeShippingBar({
    targetSelector: '.js-free-shipping-bar'
  });

  setTimeout(() => {
    freeShippingBarInstance.injectBar();
    freeShippingBarInstance.fetchAndUpdate();
  }, 1000);

  document.addEventListener('click', (e) => {
    if (e.target.closest('#_rsi-buy-now-button')) {
      setTimeout(() => freeShippingBarInstance.fetchAndUpdate(), 500);
    }
  });
});
